import styled from 'styled-components'

import { Select } from 'components/atoms/SelectField'

const Wrapper = styled('div')`
  ${Select} {
    margin: 16px 0 0;
  }
`

export default Wrapper
